<template>
  <div class="white ma-2 pa-5 d-flex flex-column rounded-lg">
    <h2 class="mb-2 text-center">Congratulations!</h2>
    <p class="text-center"><strong>You verified this device.</strong></p>

    <p>
      With a verified device, you are able to recieve rewards for the
      referrals you make every day.
    </p>

    <p class="text-center"><strong>Get started today!</strong></p>

    <div class="mt-2 ml-auto mr-auto">
    <v-btn @click="finishClick" color="primary">Finished</v-btn>
    </div>
  </div>
</template>

<script>

export default {
  name: 'ProfileCellWizardCongratulations',

  methods: {
    finishClick() {
      this.$router.back()
    },
  },
}
</script>